<div class="border-color-primary answer__field" fxLayoutAlign="stretch">
    <div fxFlex="auto" *ngIf="answer?.type !== answerType.icd">
        <app-input-text
            *ngIf="answer?.type === answerType.text"
            [placeholder]="answer?.placeholder | keyReplace: replacers"
            [reference]="answer?.reference.key"
            (updated)="updated($event)"
        >
        </app-input-text>
        <app-input-code
            *ngIf="answer?.type === answerType.code"
            [placeholder]="answer?.placeholder | keyReplace: replacers"
            [reference]="answer?.reference.key"
            [prefix]="prefix"
            [ngClass]="{ 'answer__prefix': prefix !== undefined }"
            (updated)="updated($event)"
        >
        </app-input-code>
        <app-input-number
            *ngIf="answer?.type === answerType.number"
            [placeholder]="answer?.placeholder | keyReplace: replacers"
            [reference]="answer?.reference.key"
            [dependence]="dependence"
            (updated)="updated($event)"
        >
        </app-input-number>
        <app-input-email
            *ngIf="answer?.type === answerType.email"
            [placeholder]="answer?.placeholder | keyReplace: replacers"
            [reference]="answer?.reference.key"
            (updated)="updated($event)"
        >
        </app-input-email>
        <app-input-phone
            *ngIf="answer?.type === answerType.phone"
            [placeholder]="answer?.placeholder | keyReplace: replacers"
            [reference]="answer?.reference.key"
            (updated)="updated($event)"
        >
        </app-input-phone>
    </div>
    <div class="input__wrapper" fxFlex="auto" fxLayoutAlign="stretch center" *ngIf="answer?.type === answerType.icd">
        <app-input-icd fxLayoutAlign="stretch center"
        [placeholder]="answer?.placeholder | keyReplace: replacers"
        [reference]="answer?.reference.key"
        (updated)="updated($event)"
    >
    </app-input-icd>
    </div>      
    <button mat-button data-test="input-submit" class="answer__send" color="primary" [disabled]="!valid" (click)="sendAnswer.emit(answered)">
        <span class="material-icons answer__icon">send</span>
    </button>
</div>
